import { render, staticRenderFns } from "./AccumulateProductModal.vue?vue&type=template&id=dcdedd20&scoped=true&"
import script from "./AccumulateProductModal.vue?vue&type=script&lang=js&"
export * from "./AccumulateProductModal.vue?vue&type=script&lang=js&"
import style0 from "./AccumulateProductModal.vue?vue&type=style&index=0&id=dcdedd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdedd20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VIcon,VLayout})
